<template>
  <div
    class="visualizerContainer flex flex-wrap bg-viewer justify-center items-center relative"
  >
    <div class="h-16 w-full bg-top-bar">
      <div class="w-full h-full flex relative">
        <div class="w-left-bar m-auto">
          <button
            class="zt-gtm-documents-inbox-fit-to-viewport pl-10"
            @click="fitToScreen"
          >
            <zt-icon
              class="text-zt-xl"
              name="expand-outline pointer-events-none"
            />
          </button>
        </div>
        <div class="w-right-bar flex m-auto">
          <div class="degreeProfileAndFileContent pr-3">
            {{
              this.$t(
                "message.uploadImageComponent.body.rightContainer.employeeInfo.pages"
              )
            }}
            {{ this.documents.image.page }} de
            {{ this.documents.image.totalPages }}
          </div>
          <div>
            <button class="angle-page" @click="changePageDocument('left')">
              <zt-icon name="angle-left" />
            </button>
          </div>
          <div>
            <button class="angle-page" @click="changePageDocument('right')">
              <zt-icon name="angle-right" />
            </button>
          </div>
        </div>

      </div>
    </div>
    <div id="containerZoom" class="visualizerDocument relative overflow-y-auto">
 <loading :active="isLoading"  :is-full-page="false" class="position-absolute" />
      <img
        class="absolute top-0 px-64 py-8"
        :style="`width:${documents.zoomVariable}%`"
        :src="dataPreview.page"
        alt=""
      />
    </div>
    <div
      class="flex flex-wrap w-16 absolute"
      :class="
        breakpointLg ? 'zoom-buttons-position-lg' : 'zoom-buttons-position'
      "
    >
      <zt-button
        class="mb-2"
        color="dark-100"
        icon="plus-2"
        fab
        outlined
        @click="activateZoom('sum')"
      ></zt-button>
      <zt-button
        class="mt-2"
        color="dark-100"
        icon="minus"
        fab
        outlined
        @click="activateZoom('minus')"
      ></zt-button>
    </div>
  </div>
</template>

<script>
import { useWindowResize } from "@sichern/ui-elements";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
   Loading
  },
  props: {
    dataPreview: {
      type: Object,
      default: () => {
        return {
          total_pages: 0,
          width: 0,
          height: 0,
          page: "",
        };
      },
    },
      isLoading:{
        type:Boolean,
        default:false
      },
  },
  data() {
    return {
      loading: false,
      keyReload: 1,
      documents: {
        zoomVariable: 100,
        image: {
          errorOnPage: false,
          page: 1,
          totalPages: this.dataPreview.total_pages,
        },
      },
      windowResize: useWindowResize(this),
    };
  },
  watch: {
    "documents.image.page": function(value) {
      this.$emit("get-preview", value);
    },
    loading: function(value) {},
  },
  computed: {
    breakpointLg: function() {
      return this.windowResize.width < 1024 && this.windowResize.width >= 769;
    },
  },
  methods: {
    fitToScreen() {
      this.documents.zoomVariable = 100;
    },
    activateZoom(parameter) {
      if (parameter === "sum" && this.documents.zoomVariable <= 100) {
        this.documents.zoomVariable += 10;
      } else if (parameter === "minus" && this.documents.zoomVariable > 40) {
        this.documents.zoomVariable -= 10;
      }
    },

    changePageDocument(direction) {
      if (
        direction === "right" &&
        this.documents.image.page < this.documents.image.totalPages
      ) {
        this.documents.image.page++;
      }
      if (direction === "left" && this.documents.image.page > 1) {
        this.documents.image.page--;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

//loading
.velmld-overlay {
  background-color: #717171 !important;
  height: 2em;
  margin-top: 29em;
}
//end loading

// span ------------------------------------------------------------------------------------------------------------------------------------------------

.centerProfile {
  width: 33%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.attachedArrowContainer {
  width: 10%;
  &:hover {
    cursor: pointer;
  }
  &[disabled] {
    width: 10% !important;
    visibility: hidden !important;
    cursor: not-allowed !important;
  }
}

.changeAttachedArrow.icon-LeftChevron[disabled] {
  display: none;
}

.changeAttachedArrow.icon-RightChevron[disabled] {
  display: none;
}

.degreeProfileAndFile {
  display: flex;
  // width: 33%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.degreeProfileAndFileTitle {
  color: $bluePrimary;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.degreeProfileAndFileContent {
  margin-top: 0.3em;
  color: $textSecondary;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

// FIN span --------------------------------------------------------------------------------------------------------------------------------------------

// FIN Header top bar Profile ----------------------------------------------------------------------------------------------------------------------------

.containerZoomPages {
  top: 90px;
  position: absolute;
  z-index: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  // left: 50%;
  right: 35%;
}

.navigateContainers {
  // top: 90px;
  // position: absolute;
  // z-index: 2;
  // right: 630px;
  background-color: $white;
  display: flex;
  // justify-content: flex-end;
  height: 1.6vw;
  border-radius: 3%;
}

.pagesToNavigateContainer {
  // top: 125px;
  // position: absolute;
  // z-index: 2;
  // right: 660px;
  padding-top: 0.2vw;
  display: flex;
  color: $textPrimary;
  font-size: 0.8vw;
}

.borderHalfBoxdateHour {
  border: 0.5px solid rgba(0, 0, 0, 0.12);
}

.navigateContainers .icon-Add {
  font-size: 1.1vw;
  padding: 0.03em 0.2em;
  // border-right: rgba(0, 0, 0, 0.12) 1px solid;
}

.navigateContainers .icon-Add::before {
  color: $textPrimary;
}

.navigateContainers .icon-Subtraction {
  font-size: 1.1vw;
  padding: 0.03em 0.2em;
  // border-right: rgba(0, 0, 0, 0.12) 1px solid;
}

.navigateContainers .icon-Subtraction::before {
  color: $textPrimary;
}

.comboBoxZoom {
  //   margin: 1em 0em;
  // height: 1.3vw;
  // width: 95%;
  background-color: $white;
  border: 0px;
  outline: 0px;
  padding: 0.03em 0.2em;
  color: black;
  border-radius: 5%;
}
::v-deep .zt-button-fab {
  color: #707070 !important;
  height: 35px;
  width: 35px;
}
::v-deep .zt-icon-minus {
  font-size: 1.5rem !important;
}
::v-deep .zt-icon-plus-2 {
  font-size: 1.5rem !important;
}
.visualizerContainer {
  height: 100%;
}

.bg-viewer {
  background-color: #717171;
}

.bg-top-bar {
  background-color: #c4c4c4;
}

.zoom-buttons-position {
  bottom: 6rem;
  right: 1rem;
}

.zoom-buttons-position-lg {
  bottom: 1rem;
  right: 1rem;
}

.w-left-bar {
  width: 45%;
}

.w-right-bar {
  width: 55%;
}

.angle-page:disabled {
  color: $textSecondary;
}

.visualizerDocument {
  justify-content: center;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  height: calc(100vh - 183px);
  transform-origin: top;
}

.docSizeMd {
  height: 90vw;
  width: 70vw;
}

.docSizeLg {
  height: 40vw;
  width: 30vw;
}

.docSizeXl {
  height: 80%;
  width: 80%;
}

.documentProperties {
  vertical-align: middle;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: opacity 0.5s ease-in-out;
}

.imgtest {
  width: 80%;
}

.propertiesArrows {
  height: 60vh;
  justify-content: center;
  display: flex;
  align-items: center;
}

.propertiesArrows[disabled] {
  opacity: 0;
}

.propertiesArrows:hover {
  height: 60vh;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: $textTertiary;
}

.propertiesArrows.icon-LeftChevron {
  font-size: 4em;
}

.propertiesArrows.icon-LeftChevron::before {
  color: $white;
}

.propertiesArrows.icon-RightChevron {
  font-size: 4em;
}

.propertiesArrows.icon-RightChevron::before {
  color: $white;
}

.problemWithImageText {
  color: $white;
  font-size: 1vw;
}

#visualizerDocumentLoading {
  width: 70%;
  max-width: 70%;
  height: 80%;
  display: block;
  position: absolute !important;
  overflow: hidden;
}

::v-deep #loadingForFixing {
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  font-size: 1rem;
  font-weight: 400;
  #loader-1 {
    margin-bottom: 15px;
  }
}
.position-absolute {
  position: fixed !important;
}
</style>
